// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGridCopyFromBody = {
  poolId: string;
  gridId: string;
  sourceGridId: string;
  mode: "merge" | "replace";
};

export type typeSquaresGridCopyFromOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    grid: {
      gridId: string;
      gridState: "open" | "locked" | "live" | "final" | "void";
      publishStatus: "draft" | "published";
      hasNumbers: boolean;
    };
    copiedCount: number;
    skippedCount: number;
  };
};

export type typeSquaresGridCopyFromOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridCopyFromOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridCopyFromOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGridCopyFromBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
    sourceGridId: { type: "string", maxLength: 3000, minLength: 1 },
    mode: { type: "string", enum: ["merge", "replace"] },
  },
  required: ["poolId", "gridId", "sourceGridId", "mode"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGridCopyFrom(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGridCopyFromBody);
  }

  return async function postSquaresGridCopyFrom(
    payload: typeSquaresGridCopyFromBody,
  ): Promise<
    typeSquaresGridCopyFromOutput200 | typeSquaresGridCopyFromOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGridCopyFrom" failed before calling the network. #c9109284a231`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#c9109284a231" },
        },
        data: null,
      } as typeSquaresGridCopyFromOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/grid-copy-from`,
      httpMethod: "POST",
      options,
    })) as typeSquaresGridCopyFromOutput200 | typeSquaresGridCopyFromOutput400;
  };
}
